import logger from '@goldcast/logger';
import { retrieveForm } from '@goldcast/api/backend';

const actions = {
  async fetchFormJson(context, { formId }) {
    try {
      context.commit('setFormJsonError', null);
      context.commit('setFormJsonLoading', true);

      const form = await retrieveForm({
        id: formId
      });

      const url = form?.formio_schema_url;
      if (!url) {
        return;
      }

      await fetch(url)
        .then(res => res.json())
        .then(data => {
          context.commit('setFormJson', {
            json: data,
            id: formId
          });
        })
        .catch(err => {
          logger.error('[registrationForm/actions] fetchFormJson failed', err);
          context.commit('setFormJsonError', err);
        })
        .finally(() => {
          context.commit('setFormJsonLoading', false);
        });
    } catch (err) {
      logger.error('[registrationForm/actions] fetchFormJson failed', err);
      context.commit('setFormJsonError', err);
      context.commit('setFormJsonLoading', false);
    }
  }
};

export default actions;
